'use strict';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import React, {Component} from 'react';
import * as T from 'prop-types';
import DonutChart from 'react-donut-chart';
import withAvailableWidth from '../../../_libs/react-with-available-width';
import loadingIcon from '../../../../img/loading.svg';
import noDataIcon from '../../../../img/no-data.svg';
import {StatusColors} from './status-colors';

export class BaseStatusChartComponent extends Component {
  static propTypes = {
    label: T.string.isRequired,
    metricPrefix: T.string.isRequired,
    metrics: T.object.isRequired,
    availableWidth: T.number,
  };

  render() {
    const isLoading = !isObject(this.props.metrics) || !isNumber(this.props.availableWidth);
    const count = isLoading ? 0 : this.props.metrics[`${this.props.metricPrefix}Count`];
    return (
      <div className="item entity-card">
        <div>
          <div>
            <div className="header">
              <div>
                <span>
                  {count > 0 ? count : '-'}
                </span>
              </div>
              <div>
                {this.props.label}
              </div>
            </div>
          </div>
        </div>
        <div className="item entity-stats">
          {this.renderBody(isLoading, count)}
        </div>
      </div>
    );
  }

  renderBody(isLoading, count) {
    if (isLoading) {
      return (
        <img
          className="status-image"
          src={loadingIcon}
        />
      );
    } else {
      const data = this.convertData();
      return count > 0 && this.props.availableWidth > 40 ? (
        <div>
          <DonutChart
            height={(this.props.availableWidth - 40) * 0.5}
            width={(this.props.availableWidth - 40) * 0.5}
            colors={StatusColors}
            colorFunction={getColor}
            data={data}
            legend={false}
          />
          <div className="legend">
            {data.map((item, i) => (
              <div
                key={i}
                className="legend-row"
              >
                <div style={{backgroundColor: StatusColors[i]}} />
                <span>
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <img
          className="status-image"
          src={noDataIcon}
        />
      );
    }
  }

  convertData() {
    const metrics = this.props.metrics;
    const metricPrefix = this.props.metricPrefix;
    return [{
      label: 'Approved',
      value: metrics[`${metricPrefix}Approved`],
    }, {
      label: 'Submitted',
      value: metrics[`${metricPrefix}Submitted`],
    }, {
      label: 'Rejections',
      value: metrics[`${metricPrefix}Rejected`] + metrics[`${metricPrefix}HasRejection`],
    }, {
      label: 'In Progress',
      value: metrics[`${metricPrefix}InProgress`],
    }, {
      label: 'Pending',
      value: metrics[`${metricPrefix}Pending`],
    }, {
      label: 'Cancelled',
      value: metrics[`${metricPrefix}Cancelled`],
    }];
  }
}

function getColor(c, index) {
  return StatusColors[index];
}

export const StatusChartComponent = withAvailableWidth(BaseStatusChartComponent);



// WEBPACK FOOTER //
// ./src/js/projects/components/StatusChart/StatusChartComponent.js